import React, {useEffect, useRef, useState} from 'react';
import Level1AnalyticsLogo from "../assets/img/L1AnalyticsLogo.svg";
import Api from './Api';

const Applogin = () => {

    const appLoading = useRef();
    const loginForm = useRef();
    const [rememberChecked, setRememberChecked] = useState(true);

    useEffect(() => {

        populateLogin();
        
		document.getElementById("but_appLogin_submit").addEventListener('click',      
			(event) => {
				event.preventDefault();
				event.stopPropagation();
				const loginForm = event.target.form;
				if (loginForm.checkValidity()) {
                    doRememberMe();
					submitAppLogin();
				}
				loginForm.classList.add('was-validated');
		});

		document.getElementById("pwd_appLogin").addEventListener('keydown',      
			(event) => {
                const key = event.key || event.keyCode;;
                if (key === 'Enter' || key === 13) {
                    event.preventDefault();
                    event.stopPropagation();
                    const loginForm = event.target.form;
                    if (loginForm.checkValidity()) {
                        doRememberMe();
                        submitAppLogin();
                    }
                    loginForm.classList.add('was-validated');
                }
		});

    }, []);

    const doRememberMe = () => {
        const remember = document.getElementById("chk_remember").checked;
        if (remember) {
            var cookieDate = new Date;
            cookieDate.setFullYear(cookieDate.getFullYear() +5);
            const userName = document.getElementById("txt_appLogin_username").value;
            const pwd = document.getElementById("pwd_appLogin").value;
            document.cookie = `userName=${userName.trim()}; expires= ${cookieDate.toUTCString()}`;
            document.cookie = `pwd=${pwd.trim()}; expires= ${cookieDate.toUTCString()}`;
        } else {
            document.cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC;"
            document.cookie = "pwd=; expires=Thu, 01 Jan 1970 00:00:00 UTC;"
        }
    }

    const populateLogin = () => {
        const userNameField = document.getElementById("txt_appLogin_username");
		const passwordField = document.getElementById("pwd_appLogin");
        userNameField.value = getCookieValue("userName");
        passwordField.value = getCookieValue("pwd");
    }

    function getCookieValue(name) {
        let result = document.cookie.match("(^|[^;]+)\s*" + name + "\s*=\s*([^;]+)")
        return result ? result.pop() : ""
    }

    async function submitAppLogin() {
		const userName = document.getElementById("txt_appLogin_username").value;
		const password = document.getElementById("pwd_appLogin").value;
        const loginFormDiv = loginForm.current;
        const appLoadingDiv = appLoading.current;

		const postBody = {
            "code": `${userName.trim()}/${password.trim()}`,
            "action": "e"
		}
        
        let apiObj = new Api();
        let sendResults = await apiObj.makeToken(postBody, "spinner_appLogin");

        switch(sendResults.message.toUpperCase()) {
          case "SUCCESS":
            // go to app;
            loginFormDiv.classList.add("d-none");
            appLoadingDiv.classList.remove("d-none");
            window.location.href = `${process.env.APP_URL}?token=${encodeURI(sendResults.code)}`
            break;
          default:
            // @todo - fail code block
            alert(sendResults.message);
        }

		var demoForm = document.getElementById('form_appLogin')
		demoForm.classList.remove("was-validated");
		demoForm.reset();
	}

    return (
        <div className="modal fade" id="modal_appLogin" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-start">Login</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <div className="modal-body">
                    
                        <form id="form_appLogin" className="needs-validation" ref={loginForm} novalidate>

                            <p className="text-center"><img src={Level1AnalyticsLogo} className="align-self-center" width="250" height="74" /></p>

                            <div className="row mb-2">
                                <div className="col form-floating">
                                    <input type="text" className="form-control" id="txt_appLogin_username" title="User Name" placeholder="Enter your user name..." aria-describedby="UserName" required />
                                    <label for="txt_appLogin_username">User name</label>
                                    <div className="invalid-feedback">
                                        Please provide your user name.
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col form-floating">
                                    <input type="password" className="form-control" id="pwd_appLogin" title="Password" placeholder="Enter your password..." aria-describedby="Password" required />
                                    <label for="pwd_appLogin">Password</label>
                                    <div className="invalid-feedback">
                                        Please provide your password.
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="remember" id="chk_remember" checked={rememberChecked} onChange={(e) => setRememberChecked(e.target.checked)} />
                                        <label class="form-check-label" for="chk_remember">Remember Me</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col">
                                    <div className="w-100 text-center my-2"><a href={`${process.env.APP_URL}?action=forgotpwd`}>Forgot password?</a></div>
                                    <button className="btn btn-primary form-control" id="but_appLogin_submit">
                                    <i className="spinner-border spinner-border-sm buttonspinner" role="status" id="spinner_appLogin"></i> Login
                                    </button>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col">
                                    <button type="button" className="btn btn-secondary form-control" data-bs-dismiss="modal">Cancel</button>
                                </div>
                            </div>

                        </form>

                        <div className="row apploader ratio ratio-21x9 d-none" ref={appLoading}>
                            <h5 className="text-center"><em>Loading...</em></h5>
                            <div class="col d-flex align-items-center justify-content-center">
                                <div class="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        

                    </div>

                </div>
            </div>
        </div>
    );
}

export default Applogin;
